module.exports = __webpack_public_path__ + "img/deep-excavation.e69a188.jpg";